<template>
    <transition name="slide-fade">
        <div class="modal mx-auto" :class="{'open' : open}" v-if="open">
            <div class="modal-content px-5 py-5">
                <div class="bg-white w-full rounded-40 p-4 border-b-8 border-a-black-080909">
                    <div class="font-SemiBold text-center text-20 pt-2.5 text-a-black-080909" v-html="title"></div>
                    <div class="font-Text text-center text-14 pt-5 text-a-gray-666666" v-html="message"></div>
                    <button class="font-SemiBold text-center text-16 text-a-black-080909 border border-a-black-080909 rounded-40 w-full mt-6 pt-5 pb-4" @click="clickCancel()">
                        {{btnCancel}}
                    </button>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import { inject } from "vue";

export default {
    name: "AlertModal",
    props: {
        controller: Object,
    },
    setup: function () {
        const { lbl, localeCode } = inject("LocaleStore")

        return {
            lbl,
            localeCode,
        }
    },
    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            blobConfig: '',
            btnOk: '',
            btnCancel: '',
            busModal: null,
            textStyle: {
                color : '',
            },
            backgroundStyle: {
                backgroundColor : '',
            },
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;

            // if (Util.isEmptyStr(this.btnOk)) {
            //     this.btnOk = this.lbl.base_button.confirm;
            // }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.base_button.close;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    @import '../../../style/base.scss';
    .modal {
        max-width: 414px;
        @extend %modal;
        .modal-content {
            width: 100%;
            max-width: 414px;
        }
    }
    .font-SemiBold {
        font-family: $ff-semi;
    }
    .font-Medium {
        font-family: $ff-Medium;
    }
    .font-Text {
        font-family: $ff-text;
    }
</style>
